import { Component, EventEmitter, forwardRef, Inject, Input, Output } from '@angular/core';

import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  template: require('./customer.actions.component.html')
})
export class CustomerActionsComponent {
  @Input() record: any;

  @Output() onEditClick      : EventEmitter<any> = new EventEmitter();
  @Output() onAddVehicleClick: EventEmitter<any> = new EventEmitter();
  @Output() onBookingClick   : EventEmitter<any> = new EventEmitter();
  @Output() onInvoiceClick   : EventEmitter<any> = new EventEmitter();
  @Output() onSMSClick       : EventEmitter<any> = new EventEmitter();
  @Output() onEmailClick     : EventEmitter<any> = new EventEmitter();
  @Output() onActivateClick  : EventEmitter<any> = new EventEmitter();

  session = this.sessionService.base();

  constructor (
    @Inject(forwardRef(() => SessionService)) private sessionService: SessionService
  ) {}
}